import { createGlobalStyle, css } from 'styled-components'
import { PAWN_CLASS } from '../../../pages/MapPage/mapStyles'
import { DRAWN_ITEM_CLASS } from '../../../pages/MapPage/components/DrawToolLegacy/DrawTool'
import {
  CLUSTER_ICON_CLASS,
  SELECTION_DETAIL_CLASS,
} from '../../../pages/MapPage/components/DrawToolLegacy/useMapVisualizations'

const LeafletStyles = createGlobalStyle<{ $panoActive: boolean; $smallMap: boolean }>`
  .leaflet-container {
    cursor: default;

    ${({ $panoActive, $smallMap }) =>
      $panoActive
        ? css`
            position: absolute;
            bottom: ${$smallMap ? '1rem' : '0'};
            left: ${$smallMap ? '1rem' : '0'};
            width: ${$smallMap ? '20rem' : '100%'};
            height: ${$smallMap ? '11rem' : '50%'};
          `
        : css`
            position: relative;
            width: calc(100% + 10px); // 10px extra for hiding padding of wms layers
            left: -5px;
            height: 100%;
          `}

    .leaflet-bottom {
      .leaflet-control {
        margin-right: ${({ $panoActive }) => ($panoActive ? '0.5rem' : '1rem')};
        margin-bottom: ${({ $panoActive }) => ($panoActive ? '0.5rem' : '1rem')};
      }

      .leaflet-control-scale {
        position: absolute;
        bottom: 0;
        right: 4rem;
      }
    }

    .${PAWN_CLASS} {
      z-index: 1000 !important;
    }

    .${SELECTION_DETAIL_CLASS} {
      cursor: pointer !important;
    }

    .${DRAWN_ITEM_CLASS} {
      cursor: url('/assets/cursors/edit.cur'), auto
    }

    .${CLUSTER_ICON_CLASS} {
      background-color: #EC0000;
      background-size: 100%;
      border-radius: 50%;
      border: 3px solid;
      box-shadow: 1px 1px 2px black;
      color: #fff;
      display: flex;
      flex-direction: column;
      justify-content: center;
      cursor: zoom-in;

      div {
        text-align:center;
      }
    }
  }
`

export default LeafletStyles
